// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { setNestedValueInObject } from 'helpers/reduxFormFunctions'
import { contactCodeIsValid } from 'validators/common'

const asyncValidate = async (formValues, f, props, pathString) => {
  // async validation fires one last time on submit
  // but does not include a pathString value
  // for this case, validating once again is unnecessary
  if (!pathString) {
    return
  }

  if (pathString === 'serviceContactCode') {
    return contactCodeIsValid(formValues, f, props, pathString)
  } else {
    // NOTE - this should only ever happen during development!
    const asyncErrors = props.asyncErrors || {}
    const errorMessage = 'WARNING: an unmapped field called async blur validation for New Project!'
    setNestedValueInObject(asyncErrors, pathString, errorMessage)
    throw asyncErrors
  }
}

export default asyncValidate
